import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
} from "react-icons/ai";
import { FaLinkedinIn, FaEnvelope, FaBlog } from "react-icons/fa";

const TopmateIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 1024 1024"
    fill="currentColor"
    {...props}
  >
    <circle cx="512" cy="512" r="512" fill="#5A4FCF" />{" "}
    {/* Purple background */}
    <text
      x="50%"
      y="55%"
      textAnchor="middle"
      fontSize="380"
      fill="#fff"
      fontFamily="Arial, sans-serif"
      fontWeight="bold"
    >
      T
    </text>
  </svg>
);

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }} className="intro-self">
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with programming and I have at least learnt
              something, I think… 🤷‍♂️
              <br />
              <br />
              Integrated <b className="purple"> Google CCAI + Dialogflow</b> for
              real-time agent handoff and routing
              <br />
              <br />
              Developed <b className="purple"> Node.js backend</b> services to
              connect with real-time databases &nbsp;
              <br />
              <br />
              Integrated <b className="purple">speech recognition,</b> voice
              prompts, and real-time alerts
              <br />
              <br />
              Configured <b className="purple">Google CCAI</b> for virtual agent
              routing and human escalation
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/gnanamuthugm"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  href="https://twitter.com/Soumyajit4419"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li> */}

              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/gnanamuthugm/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://topmate.io/gnanamuthugm" // replace with your Topmate profile link
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <TopmateIcon />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://ai-article-publisher.vercel.app/en" // replace with your blog URL
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  title="Personal Blog"
                >
                  <FaBlog />
                </a>
              </li>

              <li className="social-icons">
                <Link
                  to="/contact"
                  className="icon-colour home-social-icons"
                  title="Contact Me"
                >
                  <FaEnvelope />
                </Link>
              </li>

              {/* <li className="social-icons">
                <a
                  href="https://www.instagram.com/soumyajit4419"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li> */}
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
